/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Content_LabelInputs */

const es_privacy_policy_retention_content_label = /** @type {(inputs: Privacy_Policy_Retention_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido Ingestado y Metadatos`)
};

const en_privacy_policy_retention_content_label = /** @type {(inputs: Privacy_Policy_Retention_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingested Content and Metadata`)
};

/**
* | output |
* | --- |
* | "Ingested Content and Metadata" |
*
* @param {Privacy_Policy_Retention_Content_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_content_label = /** @type {((inputs?: Privacy_Policy_Retention_Content_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Content_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_content_label(inputs)
	return en_privacy_policy_retention_content_label(inputs)
});
export { privacy_policy_retention_content_label as "privacy_policy.retention.content_label" }